import * as React from 'react';
import classNames from 'classnames';
import { ITheme } from 'src/Entities/Theme';
import { RouteComponentProps, withRouter } from 'react-router';

interface IThemeSectionListParams {
  id?: string;
}

interface IThemeSectionListProps extends RouteComponentProps<IThemeSectionListParams> {
  themes: ITheme[];
  activeThemeId: number | null;
}

const ThemeSectionList = (props: IThemeSectionListProps) => {
  const handleItemClick = React.useCallback((theme: ITheme) => {
    props.history.push(`/cms/temasektioner/${theme.themeId}`);
  }, []);

  return (
    <div>
      {props.themes.map((theme) => (
        <div
          key={theme.themeId}
          onClick={() => handleItemClick(theme)}
          className={classNames(
            'mb-1 px-4 cursor-pointer',
            theme.themeId === props.activeThemeId
              ? 'has-background-white'
              : 'has-background-gray-400'
          )}
        >
          <div
            className={classNames(
              'py-6 font-bold f3',
              theme.themeId === props.activeThemeId
                ? 'has-text-black'
                : 'has-text-gray-600'
            )}
          >
            {theme.name}
          </div>
        </div>
      ))}
    </div>
  );
};

export default withRouter(ThemeSectionList);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/ThemeSectionEditor/components/ThemeSectionList.tsx